import React from "react";
import SearchIcon from "./SearchIcon.jsx";
import Checkbox from "../Generics/Controls/Checkbox.jsx";
import Listbox from "../Generics/Controls/Listbox.jsx";
import Togglebox from "../Generics/Controls/Togglebox.jsx";
import KeywordSearch from "./KeywordSearch.jsx";
import StateCountrySelector from "./StateCountrySelector.jsx";

export const fetcher = (url) => fetch(url).then((res) => res.json());
export const FilterTypes = {
	select: Listbox,
	checkboxes: Togglebox,
	textfield: KeywordSearch,
	bool: Checkbox,
	state_country_select: StateCountrySelector,
};

export const getProps = (view) => {
	const props = JSON.parse(view.getAttribute("data-props"));
	const filterOptions = drupalSettings.nada.content_api_filters[props.type].map(
		(_filter) => {
			// copy object
			const filter = { ..._filter };

      /* Dropdown adjustments */
      if (filter.label == 'Content Topic' && (props.type == 'legislative_content' || props.type == 'regulatory_content')) {
        filter.label = 'Issue Topic';
      }
      ;
      // todo add defaults to the dropdowns
			if (filter.format === "select") {
				const defaultOption = {
					id: "",
					name: 'All ' + pluralize(filter.label),
					default: true,
				};
				filter.defaultOption = defaultOption;
				filter.options = [defaultOption, ...filter.options];
			} else if (filter.format === "state_country_select") {
				const defaultCountry = {
					id: "",
					name: "All Countries",
					default: true,
				};
				const defaultState = {
					id: "",
					name: "All States",
					default: true,
				};
				filter.countries.defaultCountry = defaultCountry;
				filter.states.defaultState = defaultState;
				filter.countries.options = [
					defaultCountry,
					...filter.countries.options,
				];
				filter.states.options = Object.keys(filter.states.options).reduce(
					(acc, curr) => {
						acc[curr] = [defaultState, ...filter.states.options[curr]];
						return acc;
					},
					{}
				);
			}

			return filter;
		}
	);
	props.filterOptions = filterOptions;

	return props;
};

/**
 * Pluralizes a string
 *
 * @param {string} pluralString
 * @returns string
 */
const pluralize = (pluralString) => {
  // handle dealing with filters that end in s
  if (['ay','ey','oy','uy'].includes(pluralString.slice(-2))) {
    return pluralString.slice(0, -1) + 'ys';
  }
  else if (pluralString.slice(-1) === 'y') {
    return pluralString.slice(0, -1) + 'ies';
  } else {
    return pluralString + 's';
  }
};

/**
 * Takes in filterValues and creates the endpoint URL
 * that useInfiniteSWR will use as its key
 *
 * @param {string} baseEndpoint
 * @param {object} filterValues
 * @returns string
 */
export const _getKey = (baseEndpoint, filterValues = {}) => {
	return Object.keys(filterValues).reduce((endpoint, key) => {
		// todo: may need to check type to include booleans as needed
		const filterValue = filterValues[key];
		const keyIsArray = Array.isArray(filterValue);

		// todo: work through handling object w/ values here
		if (
			(!keyIsArray && filterValue) ||
			(keyIsArray && filterValue.length > 0)
		) {
			let value = keyIsArray
				? filterValue.join(",")
				: typeof filterValue === "object"
				? filterValue?.id || ""
				: filterValue;

			if (value) endpoint += `&${key}=${value}`;
		}

		return endpoint;
	}, baseEndpoint);
};

const safelyGetFilters = (viewFilters) => {
	try {
		return JSON.parse(viewFilters);
	} catch (err) {
		return {};
	}
};

export const defaultValuesForFilters = (filterOptions) => {
	const params = new URLSearchParams(window.location.search);
	const qpFilters = params.get("viewFilters")
		? safelyGetFilters(params.get("viewFilters"))
		: {};
	const defaultOptions = filterOptions.reduce((acc, curr) => {
		const qpValue = qpFilters[curr.id];
		switch (curr.format) {
			case "state_country_select":
				acc[curr.states.id] = curr.states.defaultState;
				acc[curr.countries.id] = curr.countries.defaultCountry;
				break;
			case "textfield":
				acc[curr.id] = qpValue || "";
				break;
			case "select":
				acc[curr.id] =
					curr.options.find((opt) => opt.id === qpValue?.id) ||
					curr.defaultOption;
				break;
			case "bool":
				acc[curr.id] = qpValue || false;
				break;
			case "checkboxes":
				acc[curr.id] = qpValue || [];
				break;
		}
		return acc;
	}, {});

	return defaultOptions;
};

export const filtersToUrl = (filters) => {
	// If we want a param per, we can look for it here
	// let searchString = "";
	// Object.keys(filters).forEach((key) => {
	// 	let symbol = searchString.length ? "&" : "?";

	// 	const value = filters[key];
	// 	if (!value) return "";

	// 	if (Array.isArray(value)) {
	// 		searchString += `${symbol}${key}=${encodeURIComponent(value.join(","))}`;
	// 	} else if (typeof value === "object") {
	// 		searchString += `${symbol}${key}=${encodeURIComponent(
	// 			JSON.stringify(value)
	// 		)}`;
	// 	} else {
	// 		searchString += `${symbol}${key}=${encodeURIComponent(value)}`;
	// 	}
	// });

	// console.log(searchString);

	history.replaceState(
		{},
		document.title,
		`${window.location.pathname}?viewFilters=${encodeURIComponent(
			JSON.stringify(filters)
		)}`
	);
};
